import {appSettings} from "./config"; 

// For a full list of MSAL.js configuration parameters, 
// visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
export const msalConfig = {
    auth: {
        clientId: "6af0873c-7d77-4372-ba94-1eba24aa7462",
        authority: "https://login.microsoftonline.com/af930677-c280-45c3-aaf1-bb933f5c5cbc",
        redirectUri: appSettings.authRedirectUri,
        validateAuthority: true,
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
}


// Coordinates and required scopes for your web API
export const apiConfig = {
    //resourceUri: "https://tecotechapi-dev.azurewebsites.net/api/profile",
    //resourceUri: "https://tecotechapi-dev.azurewebsites.net/api/profile",
    resourceScopes: "api://aafe348a-e351-49c3-bf8c-3dd3ca454a78/.default" //DEV
    //resourceScopes: "api://2bf81e35-61c5-4920-a6b1-8b1fd5be7695/.default"
}

/** 
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters, 
 * visit https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const loginRequest = {
    scopes: ["openid", "profile", "offline_access", "api://aafe348a-e351-49c3-bf8c-3dd3ca454a78/.default"]
}

// Add here scopes for access token to be used at the API endpoints.
export const tokenRequest = {
    scopes: ["api://aafe348a-e351-49c3-bf8c-3dd3ca454a78/.default"]
}

// Add here scopes for silent token request
export const silentRequest = {
    scopes: ["openid", "profile", "api://aafe348a-e351-49c3-bf8c-3dd3ca454a78/.default"]
}
